import axios from "axios";

// export const BASE_URL = "http://localhost:3100/api/v1";
// export const BASE_URL = "https://blood-bank-be.onrender.com/api/v1"
export const BASE_URL = "https://bloodbankbe.firmsewa.com/api/v1"
// export const BASE_URL = "https://bloodbankbe.firmsewa.com/api/v1"

export const Axios = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {
    Accept: "application/json",
    "content-type": "application/json",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PATCH,DELETE,POST,PUT",
    "Access-Control-Allow-Headers":
      "X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version",
    Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  },
});

export const AxiosZip = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  responseType: "blob",
  headers: {
    Accept: "/*",
    "content-type": "application/zip",
    Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  },
});

export const LoginAxios = (token) =>
  axios.create({
    baseURL: BASE_URL,
    timeout: 3000000,
    headers: {
      Accept: "application/json",
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

export const AxiosWithoutHeader = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PATCH,DELETE,POST,PUT",
    "Access-Control-Allow-Headers":
      "X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version",
  },
});

export const AxiosWithoutHeaderReset = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const AxiosWithFormData = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {
    Accept: "/*",
    "content-type": undefined,
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
    "Access-Control-Allow-Headers":
      "X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version",
    Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  },
});

export const AxiosWithFormDataWithoutToken = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {
    Accept: "/*",
    "content-type": undefined,
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,OPTIONS,PATCH,DELETE,POST,PUT",
    "Access-Control-Allow-Headers":
      "X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version",
  },
});
